"use client";

import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { CheckoutForm } from "@/checkout/types";
import {
  PAYMENT_PROVIDERS,
  PaymentProvider,
} from "@cappelendamm/e-commerce-services";
import { useTrackEvent } from "@/tracking/TrackingContext";
import { EcommerceEvent } from "@/tracking/e-commerce";

export function TrackCheckoutSubscribe() {
  const { watch, formState } = useFormContext<CheckoutForm>();
  const trackEvent = useTrackEvent();

  const [postalCode, paymentType, sku]: [string, PaymentProvider, string] =
    watch(["delivery.postalCode", "payment.type", "subscription.sku"]);

  useEffect(() => {
    trackEvent(
      EcommerceEvent({ eventName: "subscription_begin_checkout", sku }),
    );
  }, [trackEvent, sku]);

  const trackedShippingInfo = useRef<string>(null);
  useEffect(() => {
    const trackDelivery = async () => {
      trackEvent(
        EcommerceEvent({
          eventName: "subscription_add_shipping_info",
          sku,
          shipping_tier: "standard",
        }),
      );
      trackedShippingInfo.current = postalCode;
    };
    if (
      postalCode &&
      postalCode.length === 4 &&
      postalCode !== trackedShippingInfo.current
    )
      trackDelivery();
  }, [postalCode, sku, trackEvent]);

  const trackedPaymentType = useRef<string>(null);

  useEffect(() => {
    if (
      (formState.isSubmitting && !trackedPaymentType.current) || // If it hasn't changed before when the user submits
      (formState.dirtyFields.payment?.type && !trackedPaymentType.current) || // The first time the user changes it
      (paymentType !== trackedPaymentType.current && trackedPaymentType.current) // Every subsequent time the user changes it
    ) {
      trackEvent(
        EcommerceEvent({
          eventName: "subscription_add_payment_info",
          sku,
          payment_type:
            paymentType === PAYMENT_PROVIDERS.NETS ? "Kort" : "Faktura",
        }),
      );
      trackedPaymentType.current = paymentType;
    }
  }, [
    paymentType,
    trackEvent,
    sku,
    formState.isSubmitting,
    formState.dirtyFields.payment?.type,
  ]);

  return null;
}
